import { render, staticRenderFns } from "./WordDictM.vue?vue&type=template&id=3ce8bda0&scoped=true"
import script from "./WordDictM.vue?vue&type=script&lang=js"
export * from "./WordDictM.vue?vue&type=script&lang=js"
import style0 from "./WordDictM.vue?vue&type=style&index=0&id=3ce8bda0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ce8bda0",
  null
  
)

export default component.exports